import { BattleStatus } from "../../enums/enums";
import { BattleType } from "../../types/BattleType";

export const findActiveBattles = (battles: BattleType[]) => {
  return battles.filter((battle) => {
    return battle.status === BattleStatus.ACTIVE;
  })
}